import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";

import { get } from "lodash";

import Grid from "@material-ui/core/Grid";
import DropdownDown from "../VMI/assets/dropdown_arrow_down.svg";

import TrainSequence from "./TrainSequence";

import { fetchTabData } from "../../actions/siteEntranceExit/tabs"

const trainColumns = {
  ref: "15%",
  date: "15%",
  id: "20%",
  event: "10%",
  direction: "10%",
  locomotives: "10%",
  railcars: "10%",
  containers: "10%",
};
const styles = {
  mainTrainDashboard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  tabContainer: {
    marginTop: "24px",
    paddingLeft: "24px",
  },

  carouselContainer: {
    margin: "0 0 0 24px",
    height: "500px",

    padding: "12px",
    maxHeight: "500px",
    maxWidth: "calc(1502px - 16px)",
  },

  trainTrackContainer: {
    display: "flex",
    flexDirection: "column",
  },

  trainDisplayPanels: {
    width: "calc(100%-80px)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px",
  },

  trainTrackingStatus: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },

  railcarDataTable: {
    display: "flex",
    alignItems: "flex-end",
    padding: "20px 20px 0px 20px",
  },
  rcColumn: {
    display: "flex",
    flexDirection: "column",
    borderLeft: "1px solid #EFEFEF",
    borderTop: "1px solid #EFEFEF",
  },
  rcColumnSpecial: {
    marginLeft: "16px",
  },

  selectedFilter: {
    backgroundColor: "yellow",
  },

  rcEntry: {
    width: "100px",
    textAlign: "center",
    padding: "0px 4px",
    borderBottom: "1px solid #EFEFEF",
    color: "#5f00a0",
    fontWeight: "500",
  },
  actionText: {
    color: "#5f00a0",
  },
  rcLastCol: {
    backgroundColor: "#EFEFEF",
    height: "100%",
    width: "1px",
  },

  headerRow: {
    borderBottom: "1px solid #EFEFEF",

    backgroundColor: "white",
    width: "100px",
    paddingLeft: "8px",
  },
  matchFilter: {
    backgroundColor: "yellow",
  },
  headerColumn: {
    height: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  headerColTotal: {
    borderBottom: "1px solid #EFEFEF",

    backgroundColor: "#DEDEDE",
    width: "50px",
    textAlign: "center",
  },
  trainSvgIcon: {
    width: "100%",
    height: "30px",
  },

  showAll: {
    fontWeight: "500",
    cursor: "pointer",
  },

  trainTrackingInfo: {
    display: "flex",
    "& div": {
      paddingRight: "16px",
    },
  },

  trainTable: {
    margin: "24px 0 24px 0px",
    padding: "24px",
    borderRadius: "4px 4px 0px 0px",

    // maxWidth: "calc(1502px - 16px)",

    height: "276px",
  },

  tableMainContainer: {
    height: "100%",
    maxWidth: "1735px",
  },

  tableWrapper: {
    width: "100%",
    height: "100%",

    overflow: "auto",

    "& table": {
      borderCollapse: "separate",
      tableLayout: "fixed",
    },

    "& table thead tr": {
      backgroundColor: "white",

      height: "50px",
    },

    "& table thead tr th": {
      backgroundColor: "#e5f4f6",
      position: "sticky",
      top: "0px",
      zIndex: "1",
    },

    "& table thead tr th:not(:last-child)": {
      borderRight: "3px solid white",

      backgroundClip: "padding-box",
      boxSizing: "border-box",
    },

    "& table tbody tr td": {
      height: "50px",
      color: "rgba(0, 0, 0, 0.54)",
      paddingLeft: "12px",
      cursor: "pointer",
    },
  },

  tableSubtitle: {
    width: "100%",
    padding: "0 12px",
    textAlign: "left",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
  },
  sortContainer: {
    paddingLeft: "4px",
  },

  tableElement: {
    width: `calc(${trainColumns.ref} + ${trainColumns.date} + ${trainColumns.id} + ${trainColumns.event} + ${trainColumns.direction} + ${trainColumns.locomotives} + ${trainColumns.railcars} + ${trainColumns.containers})`,
  },

  tableRef: {
    width: trainColumns.ref,
  },

  tableDate: {
    width: trainColumns.date,
  },

  tableId: {
    width: trainColumns.id,
  },

  tableEvent: {
    width: trainColumns.event,
  },

  tableDirection: {
    width: trainColumns.direction,
  },

  tableLocomotives: {
    width: trainColumns.locomotives,
  },

  tableWagons: {
    width: trainColumns.railcars,
  },

  tableContainers: {
    width: trainColumns.containers,
  },

  //Text Modifiers
  boldText: {
    fontWeight: "500",
  },
  statusText: {
    fontWeight: "500",
    borderRadius: "2px",
    backgroundColor: "lightGray",
    padding: "8px",
  },
};

// const generateDate = date => {
//   const localDate = new Date(date + " UTC")
//   return localDate.toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false, minute: '2-digit', second: '2-digit' }).replace(/,/g, "")
// }

// function getWidth() {
//     return Math.max(
//       document.body.scrollWidth,
//       document.documentElement.scrollWidth,
//       document.body.offsetWidth,
//       document.documentElement.offsetWidth,
//       document.documentElement.clientWidth
//     );
//   }

  const TrainDashboard = (props) => {
    const { 
      classes, 
      dispatch, 
      language, 
      section, 
      tabIndex,
      openFromTab,
      tab, 
      log, 
      trainVisibilityFlags, 
      trainEventAttributes, 
      activeLogDetailsTab 
    } = props;

    const [trainMainEventData, setTrainMainEventData] = React.useState({})
    const [currentTrainId, setCurrentTrainId] = React.useState(null)


  React.useEffect(() => {
    console.log(`TrainDashboard - LOG CHANGED ${log?.id}`, log);
    if (log) {
      setTrainMainEventData(log)
      const trainId = log.complete.attributes.filter(att => att.id === 289)[0].value;
      setCurrentTrainId( trainId ? trainId : null)
    } else {
      dispatch(fetchTabData(section, tab))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [log, section]);

  // Event Table Sort
  const [sortRef, setSortRef] = React.useState(false);
  const [sortDate, setSortDate] = React.useState(false);
  const [sortId, setSortId] = React.useState(false);
  const [sortEvent, setSortEvent] = React.useState(false);
  const [sortDirection, setSortDirection] = React.useState(false);
  const [sortLocomotives, setSortLocomotives] = React.useState(false);
  const [sortWagons, setSortWagons] = React.useState(false);
  const [sortContainers, setSortContainers] = React.useState(false);

  

  // Render Train Content
  const HandleRender = () => {
    return <TrainSequence 
      section={section}
      tabIndex={tabIndex}
      openFromTab={openFromTab}
      activeLogDetailsTab={activeLogDetailsTab} 
      trainMainEventData={trainMainEventData} 
      trainVisibilityFlags={trainVisibilityFlags} 
      trainEventAttributes={trainEventAttributes} 
      tab={tab} 
      log={log}
    />;
  };

  return (
    <div className={classes.mainTrainDashboard}>
      {HandleRender()}

      {/* TRAIN EVENT DATA TABLE */}


      { currentTrainId ?
        <Grid
        container
        direction="column"
        wrap="nowrap"
        className={`mainContent ${classes.trainTable}`}
      >
        <Grid item className={`${classes.tableMainContainer}`}>
          <div className={classes.tableWrapper}>
            <table className={classes.tableElement}>
              <thead>
                <tr>
                  <th className={classes.tableRef}>
                    <div className={classes.tableSubtitle}>
                      <div>
                        {/* {I18n.get("companies_company")}     */}
                        Ref #
                      </div>
                      <div
                        className={classes.sortContainer}
                        onClick={() => setSortRef(!sortRef)}
                      >
                        {!sortRef ? (
                          <img
                            src={DropdownDown}
                            className={classes.dropdownInverted}
                            alt="Sort Up Arrow"
                          />
                        ) : (
                          <img src={DropdownDown} alt="Sort Down Arrow" />
                        )}
                      </div>
                    </div>
                  </th>

                  <th className={classes.tableDate}>
                    <div className={classes.tableSubtitle}>
                      <div>
                        {/* {I18n.get("site_description")}     */}
                        Date and Time
                      </div>
                      <div
                        className={classes.sortContainer}
                        onClick={() => setSortDate(!sortDate)}
                      >
                        {!sortDate ? (
                          <img
                            src={DropdownDown}
                            className={classes.dropdownInverted}
                            alt="Sort Up Arrow"
                          />
                        ) : (
                          <img src={DropdownDown} alt="Sort Down Arrow" />
                        )}
                      </div>
                    </div>
                  </th>

                  <th className={classes.tableId}>
                    <div className={classes.tableSubtitle}>
                      <div>
                        {/* {I18n.get("manufacturer_item_code")}     */}
                        Rail Detection Type
                      </div>
                      <div
                        className={classes.sortContainer}
                        onClick={() => setSortId(!sortId)}
                      >
                        {!sortId ? (
                          <img
                            src={DropdownDown}
                            className={classes.dropdownInverted}
                            alt="Sort Up Arrow"
                          />
                        ) : (
                          <img src={DropdownDown} alt="Sort Down Arrow" />
                        )}
                      </div>
                    </div>
                  </th>

                  <th className={classes.tableEvent}>
                    <div className={classes.tableSubtitle}>
                      <div>
                        Train ID
                      </div>
                      <div
                        className={classes.sortContainer}
                        onClick={() => setSortEvent(!sortEvent)}
                      >
                        {!sortEvent ? (
                          <img
                            src={DropdownDown}
                            className={classes.dropdownInverted}
                            alt="Sort Up Arrow"
                          />
                        ) : (
                          <img src={DropdownDown} alt="Sort Down Arrow" />
                        )}
                      </div>
                    </div>
                  </th>

                  <th className={classes.tableDirection}>
                    <div className={classes.tableSubtitle}>
                      <div>
                        {/* {I18n.get("sector")}     */}
                        Event
                      </div>
                      <div
                        className={classes.sortContainer}
                        onClick={() => setSortDirection(!sortDirection)}
                      >
                        {!sortDirection ? (
                          <img
                            src={DropdownDown}
                            className={classes.dropdownInverted}
                            alt="Sort Up Arrow"
                          />
                        ) : (
                          <img src={DropdownDown} alt="Sort Down Arrow" />
                        )}
                      </div>
                    </div>
                  </th>

                  <th className={classes.tableLocomotives}>
                    <div className={classes.tableSubtitle}>
                      <div>
                        {/* {I18n.get("code_bin")}     */}
                        Locomotives
                      </div>
                      <div
                        className={classes.sortContainer}
                        onClick={() => setSortLocomotives(!sortLocomotives)}
                      >
                        {!sortLocomotives ? (
                          <img
                            src={DropdownDown}
                            className={classes.dropdownInverted}
                            alt="Sort Up Arrow"
                          />
                        ) : (
                          <img src={DropdownDown} alt="Sort Down Arrow" />
                        )}
                      </div>
                    </div>
                  </th>

                  <th className={classes.tableWagons}>
                    <div className={classes.tableSubtitle}>
                      <div>
                        {/* {I18n.get("location_vmi")}     */}
                        Railcars
                      </div>
                      <div
                        className={classes.sortContainer}
                        onClick={() => setSortWagons(!sortWagons)}
                      >
                        {!sortWagons ? (
                          <img
                            src={DropdownDown}
                            className={classes.dropdownInverted}
                            alt="Sort Up Arrow"
                          />
                        ) : (
                          <img src={DropdownDown} alt="Sort Down Arrow" />
                        )}
                      </div>
                    </div>
                  </th>

                  <th className={classes.tableContainers}>
                    <div className={classes.tableSubtitle}>
                      <div>
                        {/* {I18n.get("category")}     */}
                        Containers
                      </div>
                      <div
                        className={classes.sortContainer}
                        onClick={() => setSortContainers(!sortContainers)}
                      >
                        {!sortContainers ? (
                          <img
                            src={DropdownDown}
                            className={classes.dropdownInverted}
                            alt="Sort Up Arrow"
                          />
                        ) : (
                          <img src={DropdownDown} alt="Sort Down Arrow" />
                        )}
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {/* {trainEventData.map((r, i) => (
                  <tr
                    className={`${(i + 1) % 2 === 0 ? classes.evenRow : ""}`}
                    onClick={() => console.log("openNeweventTab")}
                  >
                    <td className={classes.tableRef}>{"a"}</td>

                    <td className={classes.tableDate}>{"b"}</td>

                    <td className={classes.tableId}>{"c"}</td>

                    <td className={classes.tableEvent}>{"e"}</td>

                    <td className={classes.tableDirection}>{"f"}</td>

                    <td className={classes.tableLocomotives}>{"e"}</td>

                    <td className={classes.tableWagons}>{"g"}</td>

                    <td className={classes.tableContainers}>{"h"}</td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </div>
        </Grid>
      </Grid>
      : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
    user: state.user,
    userRole: get(state, ["user", "role"]),
    solutionsAccess: get(state, ["user", "solutionsAccess"]),
    permissions: get(state, ["user", "permissions"]),
  };
};

export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(TrainDashboard))
);
